export const COMUNI = [
  { nome: 'Alberobello' },
  { nome: 'Castellana Grotte' },
  { nome: 'Fasano' },
  { nome: 'Monopoli' },
  { nome: 'Polignano a Mare' },
];

export const PAGINATION = {
  PAGE_SIZE: 10,
  DEFAULT_SORT: 'idEvento,desc',
};

export const IMAGE_UPLOAD = {
  MAX_SIZE_BYTES: 5 * 1024 * 1024,
  ALLOWED_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif'],
};

export const EVENT_CATEGORY = {
  FOOD: 'food',
  TRADITION: 'tradition',
  TRANSPORT: 'transport',
  SOLEMARE: 'solemare',
};

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PARTITA_IVA_REGEX = /^[0-9]{11}$/;
